import type { WebReducerState } from '../reducers/types';

export const getFeatureFlags = (state: WebReducerState) =>
  state.featureFlags || {};

export const getFeatureFlagStatus = (
  state: WebReducerState,
  flagName: string,
  ifNull = false,
) => {
  const flags = getFeatureFlags(state);
  return flags?.[flagName] ?? ifNull;
};

export const getIsVaporWare = (state: WebReducerState) =>
  getFeatureFlagStatus(state, 'show-vapor-ware');
